import React from 'react';
import {
  TabContent,
  TabPane,
} from 'reactstrap';

import AdminPageEditMainEdit from './MainEdit';

const AdminPageEditTabContent = props => (
  <TabContent activeTab="1" className="settings-tab-content page-edit">
    <TabPane tabId="1">
      <AdminPageEditMainEdit
        {...props}
      />
    </TabPane>
  </TabContent>
);

export default AdminPageEditTabContent;
